import { render, staticRenderFns } from "./autoTagPicker.vue?vue&type=template&id=c2e825e0&scoped=true"
import script from "./autoTagPicker.vue?vue&type=script&lang=js"
export * from "./autoTagPicker.vue?vue&type=script&lang=js"
import style0 from "./autoTagPicker.vue?vue&type=style&index=0&id=c2e825e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e825e0",
  null
  
)

export default component.exports